import { render, staticRenderFns } from "./SignUpPageLegalData.vue?vue&type=template&id=6531bc19&"
import script from "./SignUpPageLegalData.vue?vue&type=script&lang=js&"
export * from "./SignUpPageLegalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports